import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import * as BrandConst from '../../../../constants/BrandConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import HotelContactsService from '../../../../services/HotelContactsService'
import { excludeKeyFromObjectList, scrollToHtmlElementById, searchObjectList, searchObjectListBoolean } from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './EmergencyContacts.scss'

class EmergencyContacts extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)

        const user = getSessionItem(SessionConst.USER)

        const isHotelContact = user.isHotelContact

        const isHotelDomestic = getSessionItem(SessionConst.IS_HOTEL_DOMESTIC)
        const brandName = hotelInfo.brandName
        const isWoodSpring = brandName === BrandConst.BRAND_NAME_WOODSPRING

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            isWoodSpring: isWoodSpring,
            emergencyContacts: [],
            otherContactEntries: [],
            continueFlow: this.props.history.location?.state?.continueFlow,
            isEdit: this.props.history.location?.state?.isEdit,
            editIndex: this.props.history.location?.state?.editIndex !== undefined ? this.props.history.location?.state?.editIndex : -1,
            initialValues: this.initialValues,
            showNewFields: this.props.history.location?.state?.showNewFields,
            errorMessage: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showDeleteModal: false,
            showErrorModal: false,
            isHotelContact: isHotelContact,
            isHotelDomestic: isHotelDomestic
        }
    }

    // Default initial values for form fields
    initialValues = {
        firstName: '',
        lastName: '',
        title: '',
        type: FormConst.HOTEL_CONTACT_TYPE_EMERGENCY,
        emergencyPriority: '',
        countryCode: '',
        areaCode: '',
        phoneNumber: '',
        phoneNumberType: '',
        preferred: true
    }

    // Validation schema for form fields
    validationSchema = Yup.object().shape({
        firstName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        lastName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        title: Yup.string()
            .max(FormConst.MAX_LENGTH_TITLE, `Maximum ${FormConst.MAX_LENGTH_TITLE} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        emergencyPriority: Yup.number().typeError(FormConst.VALIDATION_ERROR_NUMBERS_ONLY).required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(1, 'Min value is 1')
            .max(4, 'Max value is 4'),
        countryCode: Yup.string().test('Country code validation', function (val) {
            if ((!!this.parent.areaCode || !!this.parent.phoneNumber) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_COUNTRY_CODE, `Maximum ${FormConst.MAX_LENGTH_COUNTRY_CODE} digits`),
        areaCode: Yup.string().test('Area code validation', function (val) {
            if ((!!this.parent.countryCode || !!this.parent.phoneNumber) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_AREA_CODE, `Maximum ${FormConst.MAX_LENGTH_AREA_CODE} digits`),
        phoneNumber: Yup.string()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_PHONE_NUMBER, `Maximum ${FormConst.MAX_LENGTH_PHONE_NUMBER} digits`),
        phoneNumberType: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
    })

    /**
     * Lifecycle method that runs after the component mounts. Gets data from the service and sets initial values for the form.
     */
    async componentDidMount() {

        let existingEmergencyContacts = []
        let otherContactEntries = []
        let initialValues = { ...this.initialValues }

        // retrieve hotel contacts
        await HotelContactsService.getHotelContacts({ hotelCode: this.state.hotelCode })
            .then(response => {
                if (response?.contacts) {
                    const emergencyContacts = searchObjectList('type', FormConst.HOTEL_CONTACT_TYPE_EMERGENCY, response.contacts)
                    otherContactEntries = excludeKeyFromObjectList('type', FormConst.HOTEL_CONTACT_TYPE_EMERGENCY, response.contacts)
                    if (emergencyContacts) {
                        existingEmergencyContacts = [...emergencyContacts]
                        existingEmergencyContacts.forEach(contact => {
                            contact.countryCode = contact.phoneNumbers[0].countryCode
                            contact.areaCode = contact.phoneNumbers[0].areaCode
                            contact.phoneNumber = contact.phoneNumbers[0].number
                            contact.phoneNumberType = contact.phoneNumbers[0].type
                        })
                    }
                }

                if (this.props.history.location.state && this.props.history.location.state.isEdit && this.props.history.location.state.editIndex !== undefined) {
                    const entryToEdit = existingEmergencyContacts[this.props.history.location.state.editIndex]

                    initialValues = {
                        firstName: entryToEdit.firstName,
                        lastName: entryToEdit.lastName,
                        title: entryToEdit.title,
                        type: FormConst.HOTEL_CONTACT_TYPE_EMERGENCY,
                        emergencyPriority: entryToEdit.emergencyPriority,
                        countryCode: entryToEdit.countryCode,
                        areaCode: entryToEdit.areaCode,
                        phoneNumber: entryToEdit.phoneNumber,
                        phoneNumberType: entryToEdit.phoneNumberType,
                        preferred: true
                    }
                }

                this.setState({
                    isLoading: false,
                    emergencyContacts: existingEmergencyContacts,
                    otherContactEntries: otherContactEntries,
                    isEdit: this.props.history.location?.state?.isEdit,
                    editIndex: this.props.history.location?.state?.editIndex !== undefined ? this.props.history.location?.state?.editIndex : -1,
                    initialValues: initialValues,
                    showNewFields: this.props.history.location?.state?.showNewFields,
                })
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while retrieving Hotel Contacts data'
                })
            })
    }

    /**
     * Updates the Hotel Contacts with the form changes and calls the service with updated values.
     * 
     * @param {Object} formData The form data
     * @param {Function} resetFormData The reset method provided by formik
     * @returns {undefined}
     */
    handleSubmit = (formData, resetFormData) => {
        let emergencyContacts = [...this.state.emergencyContacts]
        const newEntry = { ...formData }

        if (this.state.isEdit) {
            // Edit existing entry
            emergencyContacts[this.state.editIndex] = newEntry
        } else {

            // If there is an entry with the priority, throw an error
            if (searchObjectListBoolean('emergencyPriority', newEntry.emergencyPriority + '', emergencyContacts)) {
                this.setState({ errorMessage: 'There is an existing entry with the same priority' })
                return
            }
            emergencyContacts.push(newEntry)
        }

        const newHotelContacts = [...this.state.otherContactEntries, ...emergencyContacts]

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newHotelContacts })

        this.setState({
            pendingEmergencyContacts: [...emergencyContacts],
            errorMessage: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            resetFormData: resetFormData
        })

    }

    /**
     * Displays reset modal
     */
    handleResetForm = () => {
        this.setState({ showResetModal: true })
    }

    /**
    * Resets form data and hides the reset modal
    * @param {Function} formikResetFormMethod the formik reset method
    */
    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false,
            initialValues: this.initialValues,
            isEdit: false,
            editIndex: -1,
            errorMessage: undefined
        })
    }

    /**
     * Discards the new contact entry and resets form data to initial values. Hides the Contact details editable fields.
     * @param {Function} resetForm the formik reset method
     */
    discardNewFields = (resetForm) => {
        resetForm({ values: this.initialValues })
        this.setState({
            initialValues: this.initialValues,
            isEdit: false,
            editIndex: -1,
            showNewFields: false,
            errorMessage: undefined,
            showResetModal: false
        })
    }

    /**
     * Lifecycle method to handle this component's update. Only handles updates which are a result of HTTP async actions.
     * 
     * @param {Object} prevProps properties before the current update
     */
    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                if (!!this.state.resetFormData) {
                    this.state.resetFormData()
                }
                // Scroll the table into view after saving
                scrollToHtmlElementById('emergency-contacts-page-table')
                this.setState({
                    isLoading: false,
                    emergencyContacts: [...this.state.pendingEmergencyContacts],
                    pendingEmergencyContacts: [],
                    isEdit: false,
                    editIndex: -1,
                    initialValues: { ...this.initialValues },
                    showNewFields: false,
                    showErrorModal: false
                })
            }
        }
    }

    /**
     * Handles transition out of the page
     */
    handleProceed = () => {
        this.props.history.push(RouteConst.ROUTE_HOTEL_CONTACTS_PAGE)
    }

    /**
     * Displays the contact details field and fills them up with the values using the contact to be edited.
     * 
     * @param {number} index the index of the entry to be edited
     */
    onEdit = (index) => {
        const entryToEdit = this.state.emergencyContacts[index]
        this.setState({
            isEdit: true,
            editIndex: index,
            initialValues: {
                firstName: entryToEdit.firstName,
                lastName: entryToEdit.lastName,
                title: entryToEdit.title,
                type: FormConst.HOTEL_CONTACT_TYPE_EMERGENCY,
                emergencyPriority: entryToEdit.emergencyPriority,
                countryCode: entryToEdit.phoneNumbers[0].countryCode,
                areaCode: entryToEdit.phoneNumbers[0].areaCode,
                phoneNumber: entryToEdit.phoneNumbers[0].number,
                phoneNumberType: entryToEdit.phoneNumbers[0].type,
                preferred: true
            },
            showNewFields: true,
            errorMessage: undefined
        })
    }

    /**
     * Displays the delete modal and sets the delete index in state
     * 
     * @param {number} index the index of the entry to be deleted
     */
    handleDelete = (index) => {
        this.setState({ showDeleteModal: true, deleteIndex: index })
    }

    /**
     * Deletes the emergency contact entry using the delete index from state and calls the service with updated contacts
     */
    onDelete = () => {
        let index = this.state.deleteIndex
        let emergencyContacts = [...this.state.emergencyContacts]
        emergencyContacts.splice(index, 1)

        let newHotelContacts

        if (emergencyContacts.length > 0) {
            newHotelContacts = [...this.state.otherContactEntries, ...emergencyContacts]
        } else {
            newHotelContacts = [...this.state.otherContactEntries]
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newHotelContacts })

        this.setState({
            pendingEmergencyContacts: [...emergencyContacts],
            isEdit: false,
            editIndex: -1,
            errorMessage: undefined,
            isLoading: true,
            showDeleteModal: false,
            deleteIndex: -1
        })
    }

    /**
     * Displays the contact details fields.
     */
    showNewEmergencyContactsFields = () => {
        this.setState({
            isEdit: false, editIndex: -1, showNewFields: true, initialValues: this.initialValues, errorMessage: undefined
        })
    }

    render() {
        let formTable = <table
            id='emergency-contacts-page-table'
            className='table table-striped table-responsive emergency-contacts-page-table'>
            <thead>
                <tr>
                    <th>Last Name</th>
                    <th>First name</th>
                    <th className='d-none d-md-table-cell'>Title</th>
                    <th className='d-none d-lg-table-cell'>Phone Number</th>
                    <th className='d-none d-md-table-cell'>Priority</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {
                    this.state.emergencyContacts?.length > 0 ?
                        (
                            this.state.emergencyContacts.map((emergencyContact, index) => {

                                let phoneNumberEntry = ''

                                if (emergencyContact.phoneNumbers && emergencyContact.phoneNumbers.length > 0) {
                                    const contactNumber = emergencyContact.phoneNumbers[0]
                                    if (contactNumber.countryCode) {
                                        phoneNumberEntry += '+' + contactNumber.countryCode + ' '
                                    }
                                    if (contactNumber.areaCode) {
                                        phoneNumberEntry += contactNumber.areaCode + ' '
                                    }
                                    if (contactNumber.number) {
                                        phoneNumberEntry += contactNumber.number + ' '
                                    }
                                }

                                return <tr key={index}>
                                    <td>{emergencyContact.lastName}</td>
                                    <td>{emergencyContact.firstName}</td>
                                    <td className='d-none d-md-table-cell'>{emergencyContact.title}</td>
                                    <td className='d-none d-lg-table-cell'>{phoneNumberEntry}</td>
                                    <td className='d-none d-md-table-cell'>{emergencyContact.emergencyPriority}</td>
                                    <td><Button name={<FaEdit />} role='link' className={this.state.showNewFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.onEdit(index)} overridedisabledflag='true' /></td>
                                    <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.handleDelete(index)} /></td>
                                </tr>
                            })
                        )
                        : (
                            <tr>
                                <td colSpan={7}>There are no entries for emergency contacts</td>
                            </tr>
                        )
                }
            </tbody>
        </table>

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data, () => resetForm({ values: this.initialValues }))
                    setSubmitting(false)
                }}>
                {
                    ({ isSubmitting, resetForm }) => (
                        <div className='emergency-contacts-page'>
                            <Form className='emergency-contacts-form-element'>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOTEL_CONTACTS_PAGE}>Hotel Contacts</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Emergency Contacts</li>
                                    </ol>
                                </nav>

                                {/* Helper text */}
                                <label className='emergency-contacts-page-helper-text'>Emergency Contacts</label>
                                <p className='helper-text'>Enter emergency contact details. You can add up to {FormConst.MAX_EMERGENCY_CONTACTS} emergency contacts.</p>

                                {/* Existing emergenct contacts table */}
                                {formTable}

                                {/* Add button which displays contact details fields.
                                Displayed only when existing contacts size is less than max allowed count.
                                Disabled when the contact details fields are displayed. */}
                                {
                                    this.state.emergencyContacts.length < FormConst.MAX_EMERGENCY_CONTACTS
                                    && <Button
                                        name='Add Emergency Contact'
                                        role="primary"
                                        type="button"
                                        id="emergency-contacts-add-button"
                                        className="emergency-contacts-add-button"
                                        disabled={this.state.showNewFields}
                                        onClick={this.showNewEmergencyContactsFields} />
                                }

                                {/* Show new emergency contact fields only when add button is clicked */}
                                {this.state.showNewFields &&
                                    <div id="emergency-contacts-page-collapse-fields" className='emergency-contacts-page-collapse-fields'>
                                        <div className='emergency-contacts-page-form-fields'>
                                            <TextInput id='firstName' name='firstName' type='text' label='First Name' isrequired='true' />
                                            <TextInput id='lastName' name='lastName' type='text' label='Last Name' isrequired='true' />
                                            <TextInput id='title' name='title' type='text' label='Title' />
                                            <TextInput id='emergencyPriority' name='emergencyPriority'
                                                type='number' label='Emergency Priority' isrequired='true'
                                                min="1" max="4" />
                                            <TextInput id='phone-number' name='countryCode' type='tel' label='Phone Number' isrequired='true'
                                                placeholder='CC'
                                                suffix={
                                                    <>
                                                        <TextInput id='area-code' name='areaCode' type='tel' label=' - ' title='Area Code' placeholder='Area Code' />
                                                        <TextInput id='phone-number' name='phoneNumber' type='tel' label=' - ' title='Phone Number' placeholder='Phone Number' />
                                                    </>} />
                                            <SelectInput id='phoneNumberType' name='phoneNumberType' type='tel' label='Phone Number Type' isrequired='true' options={FormConst.HOTEL_CONTACTS_PHONE_NUMBER_TYPES} />
                                        </div>

                                        <div className='hotel-emergency-contacts-action-buttons'>
                                            <Button
                                                id='save-button'
                                                type="submit" name={FormConst.SAVE_LINK_TEXT} />
                                            <Button
                                                id='discard-button'
                                                name={FormConst.DISCARD_LINK_TEXT}
                                                onClick={() => this.handleResetForm()}
                                                overridedisabledflag='true' />
                                        </div>
                                        {/* Error message. Used explicitly for displaying emergency priority error. Might also display any unexpected errors on the page. */}
                                        {
                                            this.state.errorMessage
                                            && <p className='emergency-contacts-page-error-message'>{this.state.errorMessage}</p>
                                        }
                                    </div>
                                }
                                <FormFooter
                                    form={
                                        {
                                            previous: { title: this.state.isWoodSpring || this.state.isHotelDomestic === FormConst.VALUE_NO
                                                ? FormConst.LABEL_HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT 
                                                : (!this.state.isHotelContact ? FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR : FormConst.LABEL_HOTEL_CONTACT_TYPE_ONBOARDING_CONTACT), 
                                                route: this.state.isWoodSpring || this.state.isHotelDomestic === FormConst.VALUE_NO
                                                ? RouteConst.ROUTE_ONLINE_TRAVEL_AGENT_CONTACT 
                                                : (!this.state.isHotelContact ? RouteConst.ROUTE_OSD_CONTACT : RouteConst.ROUTE_ONBOARDING_CONTACT) },
                                            next: { title: FormConst.LABEL_HOTEL_CONTACT_TYPE_HOTEL_CONTACTS, route: RouteConst.ROUTE_HOTEL_CONTACTS_PAGE }
                                        }
                                    }
                                    submitName={FormConst.PROCEED_BUTTON_TEXT}
                                    onSubmit={this.handleProceed}
                                    resetName={FormConst.RESET_BUTTON_TEXT}
                                    noReset
                                    submitDisabled={isSubmitting || this.state.showNewFields} />
                                <FormModal
                                    id='hotel-contacts-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h5>{this.state.loadingMessage}</h5>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='hotel-contacts-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.discardNewFields(resetForm)
                                        // Scroll the table into view after discarding
                                        scrollToHtmlElementById('emergency-contacts-page-table')
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='hotel-contacts-page-delete-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title='Delete Contact'
                                    body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.onDelete()
                                    }}
                                    cancel={() => { this.setState({ showDeleteModal: false }) }}
                                    show={this.state.showDeleteModal} />
                                <FormModal
                                    id='hotel-contacts-page-error-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    show={this.state.showErrorModal}
                                    cancel={() => this.setState({ showErrorModal: false })} />
                            </Form>
                        </div>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelContactsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_CONTACTS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(EmergencyContacts, SideNavEntryMapping.CONTACTS))